import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { authenticatedFetch, getApiUrl } from '@/utils/auth/authService';
import { log } from '@/utils/core/vueLogger.js';
import { CacheManager } from '@/utils/core/cacheManager.js';

const deliveryLocationGroupCache = new CacheManager('VueCache', 'cache', {
	maxAge: 24 * 60 * 60 * 1000,
	memoryCacheTTL: 30 * 60 * 1000,
	logCategory: 'DeliveryLocationGroup',
	keyPrefix: () => `${iframeDataBridge.getCustomer() ?? 'unknown'}.${iframeDataBridge.getCurrentUser()?.id ?? 'unknown'}.deliveryLocationGroups.`,
});

export async function getDeliveryLocationGroups(forceRefresh = false) {
	if (!forceRefresh && !deliveryLocationGroupCache.getFromMemory('all')) {
		try {
			const legacyData = await iframeDataBridge.getStorageAsync('DELIVERYLOCATIONSGROUP');
			if (legacyData) {
				log('info', 'DeliveryLocationGroup', '📦 Seeding Vue cache from legacy storage (DELIVERYLOCATIONSGROUP)');
				await deliveryLocationGroupCache.put('all', legacyData);
				deliveryLocationGroupCache.setInMemory('all', legacyData);
				return legacyData;
			}
		} catch (legacyError) {
			log('warn', 'DeliveryLocationGroup', `⚠️ Legacy storage check failed: ${legacyError.message}`);
		}
	}

	return deliveryLocationGroupCache.fetchOrCache('all', fetchDeliveryLocationGroupsFromAPI, { forceRefresh, fallback: [], backgroundRefresh: true });
}

async function fetchDeliveryLocationGroupsFromAPI() {
	const response = await authenticatedFetch(getApiUrl('Sales/DeliveryLocationGroups'), { method: 'GET' }, 'tokenSales');
	if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

	const deliveryLocationGroups = await response.json();
	log('success', 'DeliveryLocationGroup', `✅ Fetched ${deliveryLocationGroups.length} delivery location groups`);
	return deliveryLocationGroups;
}

export async function refreshDeliveryLocationGroups() {
	deliveryLocationGroupCache.clearMemory();
	await deliveryLocationGroupCache.clear();
}
